
import React, { Fragment, useEffect, useState } from 'react'
import TimeRangePicker from '../../../CommonComponents/TimeRangePicker';

import { startOfDay, endOfDay, addDays, subDays, subHours } from 'date-fns';
import { useParams } from 'react-router-dom';
import MissionService from '../../../../service/MissionService';
import CommsMain from './CommsTelemetry/CommsMain';
import { CircularProgress } from '@mui/material';
import ThreeDModelADCS from './AdcsTelemetry/ThreeDModelADCS';
import GraphanaOrbit from './QuickDeployDashboard/GraphanaOrbit';
import AdcsGrafanaPanels from './AdcsTelemetry/AdcsGrafanaPanels';
import AdcsTimeLine from './AdcsTelemetry/AdcsTimeLine';
import PayloadTelemetry from './PayloadTelemetry';
import {panelPublicUrl} from '../../../../panelurl'

interface GrafanaProops {
    TrueTwin: any
    taskListQueue?: any
    validation?: any
}
const LoaderOnMap = () => (
    <div className="loader-container">
      <CircularProgress color='inherit'/>
    </div>
  );
  const YawPitchRollComponent = ({yawPitchRoll}) => {
      return(
          <div className='d-flex flex-row position-absolute mt-3'>
              <div className='adcsCards'>
                  <div className='yawpitchrolltext'>{yawPitchRoll?.yaw}</div>
                  <div className='yawpitchrollsubtext'>Yaw  </div>
              </div>
              <div className='adcsCards'>
                  <div className='yawpitchrolltext'>{yawPitchRoll?.pitch}</div>
                  <div className='yawpitchrollsubtext'>Pitch</div>
              </div>
              <div className='adcsCards'>
                  <div className='yawpitchrolltext'>{yawPitchRoll?.roll}</div>
                  <div className='yawpitchrollsubtext'>Roll</div>
              </div>
          </div>
      )
  }

const GrafanaPanel: React.FC<GrafanaProops> = ({TrueTwin, taskListQueue, validation}) => {
    const params = useParams();
    const {
      scenario_id,truetwin_id
    } = params;
  

        const [configStep, setConfigStep] = useState<string>('EPS')
        const [timeDate, setTimeDate] = useState([new Date(), new Date()])
        const [scenarioData, setScenarioData] = useState<any>({})
        const [zoomPanel, setZoomPanel] = useState(null)
        const [ADCSButtons, setADCSButtons] = useState([
            "State", "Measurements"
        ])
        const [AdcsMeasurementsSubButtons, setAdcsMeasurementsSubButtons] = useState([
            'Attitude Determination','magnetic field and control','Motion and dynamics','navigation and positioning'
        ])
        const [currentComponent, setCurrentComponent] = useState("AttitudeDetermination");
        const [currentMeasurenmentSubButton, setCurrentMeasurenmentSubButton] = useState('Attitude Determination')
        const [COMMSButtons, setCOMMSButtons] = useState([
            "S Band", "X Band", "UHF"
        ])
        const [COMMSSubButtons, setCOMMSSubButtons] = useState([
        "UPLINK", "DOWNLINK", "SYSTEM"
        ])
        const [selectedADCSButton, setSelectedADCSButton] = useState("State")
        const [selectedCOMMSButton, setSelectedCOMMSButton] = useState("UHF")
        const [selectedCOMMSSubButton, setSelectedCOMMSSubButton] = useState("UPLINK")
        const [yawPitchRoll, setYawPitchRoll] = useState<any>({yaw : "", pitch : "", roll : ""})
        const [orbitDataSat, setOrbitDataSat] = useState<any>({satPacket : {}, gsPacket : {}, satOrbitPacket : {}, orbitPacket : {}})
        const [orbitDataSuccess, setOrbitDataSuccess] = useState(false)
        const [key, setKey] = useState(1)
       
    const Ranges = [
        {
            label: 'Last 1 hours',
            value: [subHours(new Date(), 1), new Date()]
        },
        {
            label: 'Last 2 hours',
            value: [subHours(new Date(), 2), new Date()]
        },
        {
            label: 'Last 5 hours',
            value: [subHours(new Date(), 5), new Date()]
        },
        {
            label: 'Today',
            value: [startOfDay(new Date()), endOfDay(new Date())]
        },
        {
            label: 'Yesterday',
            value: [startOfDay(addDays(new Date(), -1)), endOfDay(addDays(new Date(), -1))]
        },
        {
            label: 'last7Days',
            value: [startOfDay(subDays(new Date(), 6)), endOfDay(new Date())]
        }
    ];


    const ConfigSteps = [

        // {
        //     title: 'Overview',
        //     icon: <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        //               <path d="M9.08203 0.202168C9.66406 -0.0673894 10.3359 -0.0673894 10.918 0.202168L19.457 4.14787C19.7891 4.30022 20 4.63229 20 4.99951C20 5.36673 19.7891 5.6988 19.457 5.85116L10.918 9.79685C10.3359 10.0664 9.66406 10.0664 9.08203 9.79685L0.542969 5.85116C0.210938 5.69489 0 5.36283 0 4.99951C0 4.63619 0.210938 4.30022 0.542969 4.14787L9.08203 0.202168ZM17.3789 8.18732L19.457 9.14835C19.7891 9.30071 20 9.63278 20 10C20 10.3672 19.7891 10.6993 19.457 10.8516L10.918 14.7973C10.3359 15.0669 9.66406 15.0669 9.08203 14.7973L0.542969 10.8516C0.210938 10.6954 0 10.3633 0 10C0 9.63668 0.210938 9.30071 0.542969 9.14835L2.62109 8.18732L8.55859 10.9298C9.01053 11.1383 9.5023 11.2462 10 11.2462C10.4977 11.2462 10.9895 11.1383 11.4414 10.9298L17.3789 8.18732ZM11.4414 15.9303L17.3789 13.1878L19.457 14.1488C19.7891 14.3012 20 14.6333 20 15.0005C20 15.3677 19.7891 15.6998 19.457 15.8521L10.918 19.7978C10.3359 20.0674 9.66406 20.0674 9.08203 19.7978L0.542969 15.8521C0.210938 15.6959 0 15.3638 0 15.0005C0 14.6372 0.210938 14.3012 0.542969 14.1488L2.62109 13.1878L8.55859 15.9303C9.01053 16.1387 9.5023 16.2467 10 16.2467C10.4977 16.2467 10.9895 16.1387 11.4414 15.9303Z" 
        //               fill={configStep === 'Overview' ? '#CCF54E' : '#ABAEAF'}/>
        //           </svg>,
        // },
        {
            title: 'EPS',
            icon: <svg width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M5.99951 14.0002H0.999512C0.734295 14.0002 0.479941 13.8949 0.292405 13.7074C0.104869 13.5198 -0.000488281 13.2655 -0.000488281 13.0002V1.00024C-0.000488281 0.735028 0.104869 0.480674 0.292405 0.293138C0.479941 0.105601 0.734295 0.000244141 0.999512 0.000244141H7.62451L6.45751 2.00024H1.99951V12.0002H5.99951V14.0002ZM10.3745 14.0002L11.5415 12.0002H15.9995V2.00024H11.9995V0.000244141H16.9995C17.2647 0.000244141 17.5191 0.105601 17.7066 0.293138C17.8942 0.480674 17.9995 0.735028 17.9995 1.00024V13.0002C17.9995 13.2655 17.8942 13.5198 17.7066 13.7074C17.5191 13.8949 17.2647 14.0002 16.9995 14.0002H10.3745ZM18.9995 4.00024H20.9995V10.0002H18.9995V4.00024ZM9.99951 6.00025H12.9995L7.99951 14.0002V8.00025H4.99951L9.99951 0.000244141V6.00025Z"
                    fill={configStep === 'EPS' ? '#CCF54E' : '#ABAEAF'} />
            </svg>,
        },
        {
            title: 'OBC',
            icon: <svg width="24" height="24" viewBox="0 0 24 24" fill='none' xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 3L5.125 3L5.125 6.125L2 6.125L2 3ZM2 11.1257L5.125 11.1257L5.125 14.2507L2 14.2507L2 11.1257ZM22 19.2503L2 19.2503L2 21.7503L22 21.7503L22 19.2503ZM7.62505 3L10.75 3L10.75 6.125L7.62505 6.125L7.62505 3ZM10.75 11.1257L7.62505 11.1257L7.62505 14.2507L10.75 14.2507L10.75 11.1257ZM13.25 3L16.375 3L16.375 6.125L13.25 6.125L13.25 3ZM16.375 11.1257L13.25 11.1257L13.25 14.2507L16.375 14.2507L16.375 11.1257ZM18.875 3L22 3L22 6.125L18.875 6.125L18.875 3ZM22 11.1257L18.875 11.1257L18.875 14.2507L22 14.2507L22 11.1257Z"
                    fill={configStep === 'OBC' ? '#CCF54E' : '#ABAEAF'} />
            </svg>,
        }, {
            title: 'ADCS',
            icon: <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
            <path d="M16.3518 10.3315C17.4663 10.3334 18.548 9.95405 19.417 9.25654C19.5149 9.17877 19.5952 9.08102 19.6523 8.9698C19.7095 8.85859 19.7423 8.73647 19.7486 8.61158C19.7559 8.47925 19.7349 8.34688 19.687 8.2233C19.6391 8.09972 19.5654 7.98779 19.4707 7.89496L16.9792 5.40471C17.3287 5.05536 17.6962 4.68809 18.0457 4.32978C18.1174 4.26708 18.1801 4.20437 18.2518 4.13271C18.3317 4.04782 18.3761 3.9357 18.3761 3.81919C18.3761 3.70268 18.3317 3.59056 18.2518 3.50567C18.2102 3.46369 18.1606 3.43037 18.106 3.40763C18.0514 3.38489 17.9928 3.37319 17.9337 3.37319C17.8745 3.37319 17.816 3.38489 17.7613 3.40763C17.7067 3.43037 17.6572 3.46369 17.6155 3.50567C17.1853 3.92669 16.7731 4.3477 16.3429 4.76871L13.8513 2.27846C13.7572 2.18554 13.645 2.11295 13.5217 2.06518C13.3983 2.01741 13.2665 1.99549 13.1343 2.00077C13.0096 2.00801 12.8878 2.04123 12.7766 2.09831C12.6655 2.15539 12.5675 2.23506 12.489 2.33221C11.7447 3.26156 11.3654 4.43059 11.4225 5.6197L10.123 6.92753L8.03473 4.84037C7.95294 4.75535 7.85482 4.68771 7.74625 4.64151C7.63768 4.59531 7.52089 4.57149 7.40288 4.57149C7.28488 4.57149 7.16809 4.59531 7.05951 4.64151C6.95094 4.68771 6.85282 4.75535 6.77103 4.84037L4.01062 7.59936C3.84369 7.76719 3.75 7.99423 3.75 8.23088C3.75 8.46753 3.84369 8.69456 4.01062 8.8624L6.10334 10.9496L5.73588 11.3079C5.29257 11.7528 5.04368 12.3551 5.04368 12.983C5.04368 13.6108 5.29257 14.2132 5.73588 14.6581L7.0892 16.0107C7.30853 16.232 7.56957 16.4077 7.85723 16.5276C8.1449 16.6475 8.45349 16.7092 8.76516 16.7092C9.07684 16.7092 9.38543 16.6475 9.67309 16.5276C9.96076 16.4077 10.2218 16.232 10.4411 16.0107L10.7996 15.6524L12.8879 17.7395C13.0558 17.9064 13.2829 18 13.5197 18C13.7565 18 13.9836 17.9064 14.1516 17.7395L16.912 14.9716C17.0789 14.8037 17.1726 14.5767 17.1726 14.3401C17.1726 14.1034 17.0789 13.8764 16.912 13.7085L14.8327 11.6303L16.1322 10.3225C16.2052 10.3298 16.2785 10.3328 16.3518 10.3315ZM4.63799 8.23536L7.40736 5.46742L9.48664 7.55457L6.7307 10.3136L4.63799 8.23536ZM16.2801 14.3445L13.5197 17.1035L11.4315 15.0164L14.1919 12.2574L16.2801 14.3445ZM11.5928 6.7215C11.8195 7.54257 12.256 8.29059 12.8593 8.89209C13.4627 9.49358 14.2123 9.92788 15.0344 10.1523L9.80032 15.3836C9.52442 15.6589 9.15051 15.8135 8.76068 15.8135C8.37085 15.8135 7.99695 15.6589 7.72105 15.3836L6.35876 14.0221C6.08337 13.7463 5.92869 13.3726 5.92869 12.983C5.92869 12.5933 6.08337 12.2196 6.35876 11.9439L11.5928 6.7215ZM13.4928 8.25327C12.7882 7.55817 12.3697 6.6244 12.3199 5.63611C12.2701 4.64782 12.5927 3.67677 13.224 2.91446L16.0292 5.71823L18.8434 8.53096L18.8613 8.55784C18.0856 9.17582 17.1092 9.48641 16.1189 9.43023C15.1285 9.37404 14.1936 8.95502 13.4928 8.25327Z" fill={configStep === 'ADCS' ? '#CCF54E' : '#ABAEAF'}/>
            <path d="M20.75 16C20.75 18.7614 18.5114 21 15.75 21" stroke={configStep === 'ADCS' ? '#CCF54E' : '#ABAEAF'} stroke-width="0.5" stroke-linecap="round"/>
            <path d="M0.75 6C0.75 3.23858 2.98858 1 5.75 1" stroke={configStep === 'ADCS' ? '#CCF54E' : '#ABAEAF'} stroke-width="0.5" stroke-linecap="round"/>
            <path d="M18.75 15C18.75 17.2091 16.9591 19 14.75 19" stroke={configStep === 'ADCS' ? '#CCF54E' : '#ABAEAF'} stroke-width="0.5" stroke-linecap="round"/>
            <path d="M2.75 7C2.75 4.79086 4.54086 3 6.75 3" stroke={configStep === 'ADCS' ? '#CCF54E' : '#ABAEAF'} stroke-width="0.5" stroke-linecap="round"/>
          </svg>,
        }, 
        // Temporary commenting out the telemetry for now.
        // {
        //     title: 'TEMP',
        //     icon: <svg xmlns="http://www.w3.org/2000/svg" width="14" height="21" viewBox="0 0 14 21" fill="none">
        //     <path d="M3 3.81826C3 2.80559 3.42143 1.8344 4.17157 1.11834C4.92172 0.40228 5.93913 0 7 0C8.06087 0 9.07828 0.40228 9.82843 1.11834C10.5786 1.8344 11 2.80559 11 3.81826V8.83449C12.223 9.64738 13.1423 10.8116 13.6241 12.1578C14.1059 13.5039 14.125 14.9617 13.6788 16.319C13.2325 17.6763 12.3441 18.8622 11.1429 19.7041C9.94163 20.546 8.49026 21 7 21C5.50974 21 4.05837 20.546 2.85714 19.7041C1.6559 18.8622 0.767498 17.6763 0.32123 16.319C-0.125038 14.9617 -0.105877 13.5039 0.375923 12.1578C0.857723 10.8116 1.77702 9.64738 3 8.83449V3.81826ZM4.144 10.4C3.27017 10.9804 2.61325 11.812 2.26885 12.7736C1.92446 13.7351 1.91058 14.7766 2.22924 15.7462C2.5479 16.7158 3.18245 17.563 4.04053 18.1645C4.89861 18.766 5.93541 19.0904 7 19.0904C8.06459 19.0904 9.10139 18.766 9.95947 18.1645C10.8175 17.563 11.4521 16.7158 11.7708 15.7462C12.0894 14.7766 12.0755 13.7351 11.7311 12.7736C11.3868 11.812 10.7298 10.9804 9.856 10.4L9 9.8301V3.81826C9 3.31193 8.78929 2.82633 8.41421 2.4683C8.03914 2.11027 7.53043 1.90913 7 1.90913C6.46957 1.90913 5.96086 2.11027 5.58579 2.4683C5.21071 2.82633 5 3.31193 5 3.81826V9.8301L4.144 10.4ZM3 14.3185H11C11 15.3311 10.5786 16.3023 9.82843 17.0184C9.07828 17.7344 8.06087 18.1367 7 18.1367C5.93913 18.1367 4.92172 17.7344 4.17157 17.0184C3.42143 16.3023 3 15.3311 3 14.3185V14.3185Z" 
        //     fill={configStep === 'TEMP' ? '#CCF54E' : '#ABAEAF'}/>
        //   </svg>,
        // }, 
        {
            title: 'Comms',
            icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M9.99953 11.0002L15.9995 20.0002H3.99953L9.99953 11.0002ZM9.99953 14.6002L7.73953 18.0002H12.2595L9.99953 14.6002ZM8.93953 8.5602C8.79216 8.42288 8.67395 8.25728 8.59197 8.07328C8.50998 7.88928 8.4659 7.69065 8.46235 7.48925C8.45879 7.28784 8.49584 7.08778 8.57128 6.90101C8.64673 6.71423 8.75902 6.54456 8.90145 6.40213C9.04389 6.25969 9.21356 6.1474 9.40033 6.07196C9.58711 5.99652 9.78717 5.95947 9.98857 5.96302C10.19 5.96657 10.3886 6.01066 10.5726 6.09264C10.7566 6.17462 10.9222 6.29283 11.0595 6.4402C11.3245 6.72455 11.4687 7.10065 11.4619 7.48925C11.455 7.87785 11.2976 8.24862 11.0228 8.52345C10.7479 8.79827 10.3772 8.9557 9.98857 8.96255C9.59997 8.96941 9.22388 8.82516 8.93953 8.5602ZM3.28053 0.783203L4.69553 2.1982C3.28919 3.6047 2.49913 5.51223 2.49913 7.5012C2.49913 9.49018 3.28919 11.3977 4.69553 12.8042L3.28053 14.2192C2.39823 13.337 1.69834 12.2897 1.22083 11.137C0.743329 9.98433 0.497559 8.74888 0.497559 7.5012C0.497559 6.25353 0.743329 5.01808 1.22083 3.86539C1.69834 2.71271 2.39823 1.66538 3.28053 0.783203ZM16.7165 0.783203C17.5988 1.66538 18.2987 2.71271 18.7762 3.86539C19.2537 5.01808 19.4995 6.25353 19.4995 7.5012C19.4995 8.74888 19.2537 9.98433 18.7762 11.137C18.2987 12.2897 17.5988 13.337 16.7165 14.2192L15.3015 12.8042C16.7079 11.3977 17.4979 9.49018 17.4979 7.5012C17.4979 5.51223 16.7079 3.6047 15.3015 2.1982L16.7165 0.783203ZM6.10953 3.6112L7.52353 5.0252C7.19849 5.35021 6.94065 5.73607 6.76473 6.16073C6.58882 6.58539 6.49828 7.04055 6.49828 7.5002C6.49828 7.95986 6.58882 8.41502 6.76473 8.83968C6.94065 9.26434 7.19849 9.65019 7.52353 9.9752L6.10953 11.3892C5.07813 10.3578 4.4987 8.95885 4.4987 7.5002C4.4987 6.04156 5.07813 4.64265 6.10953 3.6112ZM13.8875 3.6112C14.9189 4.64265 15.4984 6.04156 15.4984 7.5002C15.4984 8.95885 14.9189 10.3578 13.8875 11.3892L12.4735 9.9752C12.7986 9.65019 13.0564 9.26434 13.2323 8.83968C13.4082 8.41502 13.4988 7.95986 13.4988 7.5002C13.4988 7.04055 13.4082 6.58539 13.2323 6.16073C13.0564 5.73607 12.7986 5.35021 12.4735 5.0252L13.8875 3.6112Z"
                    fill={configStep === 'COMMS' ? '#CCF54E' : '#ABAEAF'} />
            </svg>,
        },
        {
            title: 'PAYLOAD',
            icon: <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.9091 0.5C4.49237 0.5 0.363647 0.89994 0.363647 2.50004V14.5C0.363647 16.0999 4.49229 16.5 6.9091 16.5C9.32592 16.5 13.4546 16.1001 13.4546 14.5V2.50004C13.4546 0.900112 9.32592 0.5 6.9091 0.5ZM6.9091 1.50011C10.2321 1.50011 12.2462 2.15016 12.4473 2.50004C12.1956 2.89998 10.232 3.49998 6.9091 3.49998C3.58618 3.49998 1.57201 2.84993 1.37091 2.50004C1.62259 2.14999 3.63659 1.50011 6.9091 1.50011ZM1.37091 3.64998C2.73032 4.30003 5.24769 4.49991 6.9091 4.49991C8.57052 4.49991 11.088 4.29986 12.4473 3.64998V6.4499C12.2458 6.79995 10.232 7.49989 6.9091 7.49989C3.53569 7.49989 1.52195 6.84984 1.37091 6.49996V3.64998ZM1.37091 7.65006C2.73032 8.30012 5.24769 8.5 6.9091 8.5C8.57052 8.5 11.088 8.29994 12.4473 7.65006V10.45C12.2458 10.8 10.232 11.5 6.9091 11.5C3.53569 11.5 1.52195 10.8499 1.37091 10.5V7.65006ZM6.9091 15.4997C3.53569 15.4997 1.52195 14.8497 1.37091 14.4998V11.6498C2.73032 12.2999 5.24769 12.4997 6.9091 12.4997C8.57052 12.4997 11.088 12.2997 12.4473 11.6498V14.4998C12.246 14.8498 10.232 15.4997 6.9091 15.4997Z" fill={configStep === 'PAYLOAD' ? '#CCF54E' : '#ABAEAF'}/>
            </svg>,
        },
    ]

    const get_scenario_info = () => {
        if(scenario_id && scenario_id !== undefined){
            MissionService.getScenarioById(scenario_id)?.then((res) => {
            if(res.data){
                setScenarioData(res.data)     
            }
            }).catch((err) => {
            console.error(err)
            })
        }
    }

    useEffect(() => {
        get_scenario_info()
    },[scenario_id])

    const disableEscaping = () => {
        window.addEventListener("blur", function (e) {
            setTimeout(function () {
                window.focus();
            }, 0);
        });
    }

    const handleGrafanaIframePanel = () => {
        disableEscaping()
    }

    const onChangeTimeData = (data) => {
        setTimeDate(data)
    }

    const replaceFromToDateInURL = (url: string) => {
        if (timeDate) {
            return url.split('from=')[0] + 'from=' + new Date(timeDate[0]).getTime() + '&to=' + new Date(timeDate[1]).getTime() + '&var-re' + url.split('&var-re')[1]
        }
        return url
    }

    const handleTelemetryChange = (telemetry) => {
        if(telemetry)
        {
            setYawPitchRoll({
                yaw:telemetry.yaw ? telemetry.yaw : 0,
                pitch:telemetry.pitch ? telemetry.pitch : 0,
                roll:telemetry.roll ? telemetry.roll : 0
            })
              setOrbitDataSat(prevState => ({
                ...prevState,
                satOrbitPacket: {
                  ...prevState.satOrbitPacket,
                  position: {
                    ...prevState.satOrbitPacket.position,
                    cartographicDegrees: [
                        telemetry.LLH_position?.['X_pos'],
                        telemetry.LLH_position?.['Y_pos'],
                        telemetry.LLH_position?.['Z_pos']
                    ]
                  }
                }
              }));
            setKey(key+1)
        }else{
            setYawPitchRoll({
                yaw:0,
                pitch:0,
                roll:0
            })
        }
    }

    useEffect(() => {
                let data:any = []
        if (scenarioData?.['grafanaData']?.['Urls']?.[configStep]?.length > 0) {
            scenarioData?.['grafanaData']?.['Urls']?.[configStep].map((item) => {
                data.push({
                    ...item,
                    url: replaceFromToDateInURL(item['url'])
                })

            })
           let ttdata ={
                ...scenarioData,
                grafanaData: {
                    ...scenarioData?.grafanaData,
                    Urls: {
                        ...scenarioData?.['grafanaData']?.['Urls'],
                        [configStep]: [
                            ...data
                        ]
                    }
                }}
            setScenarioData(ttdata)
        }
    }, [timeDate])

    const createSatellitePackete = (availability, id) => {
        let satPacket = {
            "availability": availability,
            "billboard": {
                "eyeOffset": {
                    "cartesian": [
                        0,
                        0,
                        0
                    ]
                },
                "horizontalOrigin": "CENTER",
                "image": "data:image/png;base64,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",
                "pixelOffset": {
                    "cartesian2": [
                        0,
                        0
                    ]
                },
                "scale": 0.50,
                "show": true,
                "verticalOrigin": "CENTER"
            },
            "description": "",
            "id": "sat1",
            "label": {
                "fillColor": {
                    "rgba": [
                        255,
                        255,
                        255,
                        255
                    ]
                },
                "font": "montserrat",
                "horizontalOrigin": "LEFT",
                "outlineColor": {
                    "rgba": [
                        0,
                        0,
                        0,
                        255
                    ]
                },
                "outlineWidth": 2,
                "pixelOffset": {
                    "cartesian2": [
                        12,
                        0
                    ]
                },
                "show": true,
                "style": "FILL_AND_OUTLINE",
                "text": "",
                "verticalOrigin": "CENTER"
            },
            "name": "sat1",
            "position": {
                "cartographicDegrees": [
                    118.16982096578317,
                    -14.235754049307642,
                    451.08358441683043,
                ]
            }
        }
        return satPacket
    }

    useEffect(() => {
        if (configStep === "ADCS") {
            let scenarioID = validation ? validation?.['scenarioId'] : scenario_id
            let truetwinId = validation ? TrueTwin?.['trueTwinId'] : truetwin_id

            const propagation = true
            MissionService.getOribtData(scenarioID, truetwinId)?.then((res) => {
                if (res?.data) {
                    res?.data?.map((satellite) => {
                        if (satellite.id.includes("Satellite")) {
                            setOrbitDataSat(
                                {
                                    satPacket : res?.data[0],
                                    gsPacket : res?.data[1],
                                    satOrbitPacket: createSatellitePackete(satellite.availability, satellite.id),
                                    orbitPacket: satellite
                                }
                            )
                            setOrbitDataSuccess(true)
                        }
                    })
                }
            }).catch((err) => {
                console.log(err)
            })
        }
    }, [configStep])

    const handleAdcsMesurenmentChange = (selectedTab) => {
        switch(selectedTab){
            case "Attitude Determination":
                setCurrentComponent("AttitudeDetermination")
                break;
            case "magnetic field and control" :
                setCurrentComponent("MagneticFieldAndControl")
                break;
            case "Motion and dynamics" :
                setCurrentComponent("MotionAndDynamics")
                break;
            case "navigation and positioning" :
                setCurrentComponent("NavigationAndPositioning")
                break;    
        }
    }

    const replaceValidationPanelURL = (url) => {
        if (validation && Object.keys(validation).length > 0) {
            let startTime = new Date(validation?.['startTime']).getTime()
            let endTime = (validation?.['endTime'] && (new Date(validation?.['startTime']).getTime() !== new Date(validation?.['endTime']).getTime())) ? new Date(validation?.['endTime']).getTime() : 'now' 
            
            return url.split('from=')[0] + 'from=' + startTime + '&to=' + endTime + '&var-re' + url.split('&var-re')[1]
        }else{
            return url
        }
      }

      const handleAdcsStateChange = (e) => {
        e.target.value === "Measurements" ? setSelectedADCSButton("Measurements") : setSelectedADCSButton("State")
      }
    return (
        <div className='simulate-grafana-full p-0' >
            <div>
                <span className='menu-border w-100'></span>

                <div className='d-flex w-100 align-items-center justify-content-between px-5 pt-6'>
                    <div className='d-flex align-items-center gap-3'>
                        {/* <strong className='fs-14 color-atmos-secondary'>TELEMETRY</strong> */}
                        {taskListQueue && taskListQueue?.['simulation_time_abs'] && (
                            (() => {
                                const timestamp = new Date(taskListQueue['simulation_time_abs'] * 1000);
                                const formattedDate = `${timestamp.getUTCFullYear()}-${String(timestamp.getUTCMonth() + 1).padStart(2, '0')}-${String(timestamp.getUTCDate()).padStart(2, '0')} ${String(timestamp.getUTCHours()).padStart(2, '0')}:${String(timestamp.getUTCMinutes()).padStart(2, '0')}:${String(timestamp.getUTCSeconds()).padStart(2, '0')} UTC`;
                                return <span style={{ fontFamily: 'monospace' }}>{formattedDate}</span>;
                            })()
                        )}
                    </div>
                    <div className='w-40 d-flex gap-3 d-flex align-items-center h-30 border-primary border-bottom ms-9'>
                    {ConfigSteps
                             .map((item, i) => {
                                const hide_coms = TrueTwin?.['Category'] === "TrueTwin" && item?.title === 'Comms';
                                const hide_payload = TrueTwin?.['isRemoteAppConfigured'] === 'No' && item?.title === 'PAYLOAD';

                                return (
                                    <div key={i} className={`w-40 h-100 pb-2 gap-2 align-items-center justify-content-center h-100 cursor-pointer text-uppercase ${(hide_coms || hide_payload) ? 'd-none' : 'd-flex '}`} style={{borderBottom: item.title === configStep ? '2px solid #CCF54E' : '', marginBottom: '-2px'}}
                                        onClick={() => {
                                            setConfigStep(item.title);
                                        }}
                                    >
                                        <span>{item.icon}</span>
                                        <span style={{color: item.title === configStep ? '#CCF54E' : 'gray' }}>{item.title}</span>
                                    </div>
                                );
                            })}
                    </div>
                    {TrueTwin?.['truetwincreatestarttime'] && configStep !== "Comms" && <div className='z-0'>
                        <TimeRangePicker startDate={TrueTwin?.['truetwincreatestarttime']}  Ranges={Ranges} onChangeTimeData={onChangeTimeData}/>
                    </div>}
                    
                    {
                        configStep === "Comms" && <div>
                            {
                                COMMSButtons?.map((selectedButton) => (
                                    <button
                                        value={selectedButton}
                                        className={selectedButton === selectedCOMMSButton ? 'mx-1 graphanaButtonsActive' : 'mx-1 graphanaButtons'}
                                        disabled={selectedButton === 'X Band'}
                                            onClick={(e:any) => {
                                            setSelectedCOMMSButton(e.target.value)
                                        }}> {selectedButton} </button>
                                ))
                            }
                        </div>
                    }
                </div>
                {configStep === "Comms" && (
                        <div className='mt-4 d-flex justify-content-between align-items-start'>
                            {/* Left corner - Buttons */}
                            {selectedCOMMSButton === "UHF" && <div className='d-flex' style={{marginLeft:"25%"}}>
                                {COMMSSubButtons
                                    .filter(selectedButton => !(selectedCOMMSButton === 'UHF' && selectedButton === 'SYSTEM'))
                                    .map(selectedButton => (
                                        <button
                                            key={selectedButton}
                                            value={selectedButton}
                                            className={selectedButton === selectedCOMMSSubButton ? 'mx-1 graphanaButtonsActive' : 'mx-1 graphanaButtons'}
                                            onClick={(e:any) => {
                                                setSelectedCOMMSSubButton(e.target.value)
                                            }}
                                        >
                                            {selectedButton}
                                        </button>
                                ))}
                            </div>}
                            <div></div> 
                            {/* Right corner - TimeRangePicker */}
                            {TrueTwin?.['truetwincreatestarttime'] && (
                            <div className='z-0 ml-auto mr-2'>
                                <TimeRangePicker startDate={TrueTwin?.['truetwincreatestarttime']} Ranges={Ranges} onChangeTimeData={onChangeTimeData}/>
                            </div>
                            )}
                        </div>
                )}
            </div>
            <div className='simulate-grafana-body-full overflow-hidden py-3'>
                {configStep === "ADCS" &&
                <div className='d-flex w-100 align-item-center ps-7 mb-2'>
                    {
                    ADCSButtons?.map((selectedButton) => (
                            <button
                                value={selectedButton}
                                className={selectedButton === selectedADCSButton ? 'mx-1 graphanaButtonsActive' : 'mx-1 graphanaButtons'}
                                onClick={(e)=>{
                                    handleAdcsStateChange(e)
                                }}
                                > {selectedButton} </button>
                        ))
                    }
                    {/* <div className='d-flex ms-auto'>
                        <TimeRangePicker startDate={TrueTwin?.['truetwincreatestarttime']} Ranges={Ranges} onChangeTimeData={onChangeTimeData}/>
                    </div> */}
                </div>
                }
                {/* {configStep === "ADCS" && selectedADCSButton=="Measurements" &&
                    <div className='d-flex pb-3 '>
                        {AdcsMeasurementsSubButtons?.map((item, index) => (
                                <div key={index} className={`m-2 grafana-adcs-measurenment-tab ${item===currentMeasurenmentSubButton ? 'active' : ''}`} onClick={()=>handleAdcsMesurenmentChange(item)}> {item} </div>    
                        ))}
                    </div> 
                } */}

                <div className='grafana_body_scroll h-100 ps-5'>
                    {/* {selectedADCSButton=="State" && configStep === "ADCS" &&
                        <div >
                            {orbitDataSuccess && <div className='d-flex align-item-center gap-3'>
                                <div className='w-60 h-400'> <GraphanaOrbit orbitData = {orbitDataSat} key = {key}/> </div>
                                <div className='w-40 h-400 d-flex position-relative'>
                                    <YawPitchRollComponent yawPitchRoll = {yawPitchRoll}/> <ThreeDModelADCS yawPitchRoll= {yawPitchRoll} key = {key}/>
                                </div>
                            </div>}
                            {!orbitDataSuccess && <div className='d-flex align-item-center gap-3'>
                                <div className='w-60 h-400'> <LoaderOnMap/> </div>
                                <div className='w-40 h-400 d-flex position-relative'>
                                    <LoaderOnMap/>
                                </div>
                            </div>}
                            <div className='border h-30 z-999' style={{backgroundColor:"black"}}>
                                <AdcsTimeLine handleTelemetryChange={handleTelemetryChange}/>
                            </div>
                        </div>
                    } */}

                    { configStep && configStep === "ADCS" &&
                        <AdcsGrafanaPanels
                            adcs_pannels= {scenarioData?.['grafanaData']?.['Urls']?.[configStep]}
                            selectedADCSButton={selectedADCSButton}
                            handleGrafanaIframePanel={handleGrafanaIframePanel}
                            validation={validation}
                            setCurrentMeasurenmentSubButton = {setCurrentMeasurenmentSubButton}
                            currentComponent = {currentComponent}
                            setCurrentComponent= {setCurrentComponent}
                        />
                    }

                    {configStep && configStep === 'PAYLOAD' && scenarioData && 
                        <PayloadTelemetry 
                            scenarioData = {scenarioData}
                            configStep = {configStep}
                            replaceValidationPanelURL={replaceValidationPanelURL}
                        />
                    }


                    {configStep && scenarioData?.['grafanaData']?.['Urls']?.[configStep] !== null && configStep !== "Comms" && configStep !== "ADCS" && configStep !== 'PAYLOAD' &&
                        scenarioData?.['grafanaData']?.['Urls']?.[configStep]?.length > 0 && scenarioData?.['grafanaData']?.['Urls']?.[configStep].map((item,i) =>{
                            if(zoomPanel !== null && zoomPanel?.['panel_name'] === item?.['panel_name']){
                                return(
                                    <div key={i} className={`position-relative ${item?.['panel_name'] === zoomPanel?.['panel_name'] ? 'simulate-grafana-panel expandable' : 'simulate-grafana-panel'} mb-3`}>
                                        {/* <div className='grafana__panel__zoom__btn' onClick={()=>{setZoomPanel(zoomPanel?.['panel_name'] === item?.['panel_name'] ? null : item)}}>
                                            <i className={`lnr lnr-frame-expand fs-23`}/>  
                                        </div> */}
                                        <iframe src={`${panelPublicUrl}${replaceValidationPanelURL(zoomPanel?.['url'])}`} loading="lazy" onLoad={handleGrafanaIframePanel} />
                                    </div>
                                )
                            }else if(zoomPanel === null){
                                return(
                                    <div key={i} className={`position-relative ${item?.['panel_name'] === zoomPanel?.['panel_name'] ? 'simulate-grafana-panel expandable' : 'simulate-grafana-panel'} mb-3`}>
                                        {/* <div className='grafana__panel__zoom__btn' onClick={()=>{setZoomPanel(zoomPanel?.['panel_name'] === item?.['panel_name'] ? null : item)}}>
                                            <i className={`lnr lnr-frame-expand fs-23`}/>  
                                        </div> */}
                                        <iframe src={`${panelPublicUrl}${replaceValidationPanelURL(item?.['url'])}`} loading="lazy" onLoad={handleGrafanaIframePanel} />
                                    </div>
                                )
                            }
                        })
                    }

                    {/* COMMS TELEMETRY COMPONENT START */}
                        {
                            configStep && configStep === "Comms" &&
                                <CommsMain
                                    selectedCOMMSSubButton={selectedCOMMSSubButton}
                                    configStep={configStep}
                                    commsPanels= {scenarioData?.['grafanaData']?.['Urls']?.[configStep]}
                                    scenarioId={validation ? validation?.['scenarioId'] : scenario_id}
                                    trutwinId={validation ? TrueTwin?.['trutwinId'] : truetwin_id}
                                    validation={validation}
                                    selectedCOMMSButton={selectedCOMMSButton}
                                />
                        }
                    {/* COMMS TELEMETRY COMPONENT END*/}
                </div>

            </div>
            
        </div>
  )
}

export default GrafanaPanel
